import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {Employee} from 'main/stores/employees';
import _ from 'lodash';
import TimeTrackingPolicy from './TimeTrackingPolicy';

class TimeTrackingPayrollHoursSummary extends DomainObject {
  employee;
  policy;
  regular;
  overtime;
  doubleOvertime;
  holidaysTotal;
  total;
  ptoTotal;
  approved;
  dimensionsTotals;

  errors = {};

  _relations = {
    employee: Employee,
    policy: TimeTrackingPolicy
  };

  constructor(other) {
    super();

    makeObservable(this, {
      employee: observable,
      policy: observable,
      regular: observable,
      overtime: observable,
      doubleOvertime: observable,
      holidaysTotal: observable,
      total: observable,
      ptoTotal: observable,
      approved: observable,
      dimensionsTotals: observable,
      errors: observable,
      errorMessage: computed
    });

    this.merge(other);
  }

  get errorMessage() {
    if (_.isEmpty(this.errors)) return '';

    return this.errors.base || _.find(this.errors.entries, entry => !!entry).endTime;
  }
}

export default TimeTrackingPayrollHoursSummary;
